export default __webpack_public_path__ + "imgs/80dd3cd7954c0daef9ce217923be80c4.png";